<template>
  <!-- ref="dialogRef" теперь будет ссылаться на переменную из setup -->
  <q-dialog
    ref="dialogRef"
    persistent no-shake
    :full-width="!isMobile"
    :maximized="isMobile"
    @hide="onDialogHide"
  >
    <movement-create-component
      :existing-movement-id="existingMovementId"
      :create-type="createType"
      :read-only="readOnly"
      @close="handleClose"
    />
  </q-dialog>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-facing-decorator'
import { useDialogPluginComponent } from 'quasar'
import MovementCreateComponent from '../MovementCreateComponent.vue'
import { useBreakpoints } from '@/composables/useBreakpoints'

@Component({
  components: { MovementCreateComponent },
  emits: [...useDialogPluginComponent.emits],
  // Используем setup для корректной инициализации хука диалога
  setup() {
    const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
    const { isMobile } = useBreakpoints()
    return {
      dialogRef,
      onDialogHide,
      onDialogOK,
      onDialogCancel,
      isMobile
    }
  }
})
export default class MoveInfoDialog extends Vue {
  @Prop({ required: true }) existingMovementId!: string
  @Prop({ required: true }) createType!: string
  @Prop({ type: Boolean, default: false }) readOnly!: boolean

  // Эти свойства будут доступны из setup() автоматически в этом экземпляре
  declare dialogRef: any
  declare onDialogHide: () => void
  declare onDialogOK: (payload?: any) => void

  handleClose() {
    // Теперь это вызовет метод из setup
    this.onDialogOK()
  }
}
</script>
